export default __webpack_public_path__ + "static/media/facebookIcon.2268fcb1.webp";